import { DanaSendInvoiceTypeEmailApiParameter, sendInvoiceTypeEmail } from "@dana/Services/DanaOrderRelatedService";
import { InvoiceDetailsResponse } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,    
} from "@insite/client-framework/HandlerCreator";

type PostInvoicesTypeEmailParameter = {
    recipientEmailAddress?: string;
    orderPackingSlipResponse?: InvoiceDetailsResponse;
    packingHtml:string;
    invoiceType:string;
  
}& HasOnSuccess<any> & HasOnError;

type HandlerType = ApiHandlerDiscreteParameter<PostInvoicesTypeEmailParameter, DanaSendInvoiceTypeEmailApiParameter>;

export const SendDataToApi: HandlerType = async props => {
   await sendInvoiceTypeEmail({
        recipientEmailAddress:props.parameter.recipientEmailAddress,  
        orderPackingSlipResponse: props.parameter.orderPackingSlipResponse,
        packingHtml:props.parameter.packingHtml,
        invoiceType:props.parameter.invoiceType,
        
    });
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [SendDataToApi];

const PostInvoicesTypeEmailHandler = createHandlerChainRunner(chain, "PostInvoicesTypeEmailHandler");
export default PostInvoicesTypeEmailHandler;